import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

export default function SpacerNew({ blok }) {
  const spacerClasses = clsx(
    'block',
    'overflow-hidden',
    blok.desktopspacing,
    blok.mobilespacing,
    blok.custom_classes
  );

  return (
    <div
      {...storyblokEditable(blok)}
      className={spacerClasses}
      aria-hidden="true"
    />
  );
}
